module.exports = "/_next/static/images/VenturaLogo-1ced9428036ba43293cc00ae9a10d7dd.png";